// extracted by mini-css-extract-plugin
export var container = "_84-0";
export var containerTopRight = "_84-1";